<template>

    <div id="skills_tab" class="flex_content">
        <div class="container data_table_view">
            <div v-if="dataLoaded">

                <TableWrapper tableContainerId="positions_table_container" v-if="currentRef">

                    <template v-slot:tableHead>

 
                        <tr>
                            <th class="eval_username">{{ $t('modules.positions.evals_detail.candidates') }}</th>
                            <th :class="matchingSortingActive()"
                                class="sortable_column"
                                data-tooltip="Score de matching"
                                @click="reorderEval('matching_score')">%</th>
                            <th :class="activeSortingClass(key)"
                                class="sortable_column"
                                :data-tooltip="tooltipLabel(key)"
                                v-for="(texts, key) in currentPosition.actual_agences_texts"
                                :key="key"
                                @click="reorderEval(key)">
                                    <!-- <span>{{ $t('modules.evaluations.edit.skillsTab') }}</span> -->
                                    <span>{{ texts.title  }}</span>
                            </th>
                        </tr>
                    </template>

                    <template v-slot:tableBody>



                        <tr class="evalution_item_name"
                            v-for="(evaluation, index) in evaluations"
                            :index="index" :key="evaluation.id" >
                            <td class="eval_username">
                                <router-link :to=" '/evaluations/' + evaluation.id ">
                                    {{ evaluation.candidate_username }}
                                </router-link>
                            </td>

                            <td class="matching_col"
                                :class="matchingClass(evaluation.saven_test.matching_score.toFixed(0))">
                                {{ evaluation.saven_test.matching_score.toFixed(0) }}%
                            </td>

                            <td
                                v-for="(data, key) in evaluation.saven_test.actual_data"
                                :index="key" :key="key" >
                                <div :class="proximityClass(data.score, key)" class="circle_score">{{ score_label(data) }}</div>
                            </td>
                        </tr>

                    </template>

                </TableWrapper>

            </div>
        </div>
    </div>

</template>

<script>
    import s3SkillsLabels from '@/locales/s3SkillsLabels'

    export default {
        name: 'PostitionEvalsActualTab',
        props: ["evaluations", "currentPosition", "currentRef", "dataLoaded"],
        components: {
        },
        beforeCreate() {

        },
        data(){
            return {
                current_sorting: null,
            }
        },
        computed: {
        },
        methods: {
            reorderEval(key){
                this.current_sorting = key
                this.$emit('reorderEval', key)
            },
            activeSortingClass(key){
                if (key + '_score' == this.current_sorting){
                    return 'active'
                }else{
                    return ''
                }
            },
            matchingSortingActive(){
                if ('matching_score' == this.current_sorting){
                    return 'active'
                }else{
                    return ''
                }
            },
            proximityClass(score, key){
                const prox = Math.abs(this.currentRef.sight3_scores[key] - score.toFixed(0))
                return "proximity_" + prox
            },
            key_trad(key){
                const trad = 'dimensions.skills_short.' + keycircle_score
                return this.$t(trad)
            },
            tooltipLabel(key){

                return s3SkillsLabels[this.$i18n.locale][key]

            },
            matchingClass(val){
                if(val < 25){return 'low'}
                if(val >= 25 && val < 50){return 'middleLow'}
                if(val >= 50 && val < 75){return 'middleHigh'}
                if(val >= 75){return 'high'}
            },
            score_label(scoreData){
                let score = scoreData.score * 100 / 5
                return score.toFixed(0) + '/100'
            },
            ref_score(scoreData){
                let score = scoreData.ref_score * 100 / 5
                return score.toFixed(0)
            },

        }
    }
</script>

<style lang="scss" scoped>
th{
    text-align: center!important;
    user-select: none;
}
.sortable_column{
    cursor: pointer;
}
th.active{
    background: #d2ddea;
}
td{
    text-align: center;
    color: #8f9aaa;
    height: 40px!important;
    padding-top: 6px!important;
    padding-bottom: 6px!important;
}
.ref_score{
    height: 40px;
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    font-weight: 600;
    font-size: 1.2rem;
}
.circle_score{
    height: 40px;
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    font-weight: 600;
    font-size: 1.2rem;
    // background: #d2d2d2;
    background: white;
    margin: auto;
    &.proximity_0{
        color: $white;
        background: $score-diff1;
    }
    &.proximity_1{
        color: $white;
        background: $score-diff2;
    }
    &.proximity_2{
        color: $white;
        background: $score-diff3;
    }
    &.proximity_3{
        color: $white;
        background: $score-diff4;
    }
    &.proximity_4{
        color: $white;
        background: $score-diff5;
    }
}
.data_table_view {
    padding-top: 50px;
    // overflow-x: auto;
}
.ref_line{
    // background: #d2d2d2;
}
.super_head{
    background: #e4e4e4;
}
.super_head2{
    // background: #d2d2d2;
}
.matching_col{
    font-weight: 700;
    font-size: 1.25rem;
    &.low{
        color: $score-diff4;
    }
    &.middleLow{
        color: $score-diff3;
    }
    &.middleHigh{
        color: $score-diff2;
    }
    &.high{
        color: $score-diff1;
    }
}
.eval_username{
    text-align: left!important;
}
td.eval_username{
    text-align: left!important;
    font-weight: 500;
}
</style>
